import React from "react";
import { CircleCheck } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
const categories = [{
  id: 1,
  title: "INTEGRATION & IMPLEMENTATION"
}, {
  id: 2,
  title: "SAFETY & COMPLIANCE"
}, {
  id: 3,
  title: "MACHINE VISION"
}];
const services = [{
  categoryId: 1,
  title: "Turnkey System Integration",
  description: "Complete end-to-end deployment of automated systems into existing industrial workflows."
}, {
  categoryId: 1,
  title: "PLC & HMI Programming",
  description: "Custom logic development and intuitive interface design for seamless machine control."
}, {
  categoryId: 1,
  title: "Control Panel Design & Build",
  description: "UL-certified industrial control panels engineered for reliability and performance."
}, {
  categoryId: 1,
  title: "Legacy System Migration",
  description: "Upgrading outdated control systems to modern, supported hardware and software platforms."
}, {
  categoryId: 1,
  title: "SCADA & IIoT Solutions",
  description: "Implementing data acquisition and industrial internet of things for real-time monitoring."
}, {
  categoryId: 2,
  title: "Risk Assessment & Auditing",
  description: "Comprehensive evaluation of machinery to ensure compliance with global safety standards."
}, {
  categoryId: 2,
  title: "Safety Circuit Design",
  description: "Engineering redundant fail-safe systems to protect personnel and high-value assets."
}, {
  categoryId: 2,
  title: "Guard Design & Installation",
  description: "Physical safeguarding solutions tailored to specific machine hazards and operator needs."
}, {
  categoryId: 2,
  title: "Safety Validation Services",
  description: "Rigorous testing and documentation to verify that safety systems meet design intent."
}, {
  categoryId: 3,
  title: "Quality Inspection Systems",
  description: "High-speed automated visual inspection for defect detection and dimensional accuracy."
}, {
  categoryId: 3,
  title: "Guided Robotic Picking",
  description: "Advanced 2D and 3D vision systems for precise part identification and handling."
}, {
  categoryId: 3,
  title: "Traceability & Serialization",
  description: "Automated data capture and tracking systems for regulatory compliance and process control."
}, {
  categoryId: 3,
  title: "Deep Learning & AI Vision",
  description: "Utilizing neural networks for complex pattern recognition and non-linear defect detection."
}];
export default function ServiceCategories() {
  return <section id="servicecategories" className="bg-background py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-default font-bold text-foreground mb-4">
            ABCO South Automation Group
            <br />
            Core Capabilities
          </h2>
          <p className="text-muted-foreground font-sans max-w-2xl mx-auto text-lg">
            Delivering robust, industrial-grade solutions tailored to elevate
            your operational efficiency and safety standards.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-0 auto-rows-fr">
          {categories.map((category, i) => <Card key={category.id} data-index={i} className="text-card-foreground w-full h-full bg-card rounded-md border border-border shadow-sm transition-shadow duration-300 gap-0 overflow-hidden flex flex-col hover:shadow-md">
              <CardHeader className="pt-8 pb-6 px-4 bg-muted/20 min-h-[160px] flex items-start justify-start text-left">
                <CardTitle className="font-semibold font-default text-ring leading-tight whitespace-pre-line !font-normal !text-3xl">
                  {category.title}
                </CardTitle>
              </CardHeader>
              <Separator />
              <CardContent className="flex flex-col gap-6 flex-grow pt-6">
                {services.filter(s => s.categoryId === category.id).map((service, j) => <div key={j} data-index={j} className="flex items-start gap-3 group">
                      <CircleCheck className="w-5 h-5 text-ring shrink-0 mt-0.5 opacity-80 group-hover:opacity-100 transition-opacity" />
                      <div className="flex flex-col">
                        <h4 className="font-sans font-semibold text-foreground text-base">
                          {service.title}
                        </h4>
                        <p className="font-sans text-muted-foreground text-sm mt-1 leading-relaxed">
                          {service.description}
                        </p>
                      </div>
                    </div>)}
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}